export const LOGIN_CHECK = 'LOGIN_CHECK'
